
function SingleSignal() {
    /// <summary>
    /// This object provides js functions for the Widget.DataCenter.Tools.SingleSignal.vb. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 24.4.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 24.4.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}
SingleSignal.prototype = new vcTemplate();


SingleSignal.prototype.init = function () {
    /// <summary>
    /// Inits the form and the chart. <br/>
    /// </summary>   
    var me = this;
    try {

       
        me.visual.find("#div-content").height(me.height -parseInt(me.visual.find("#div-menu").height(),10) - 50);

         me.visual.find('#txt-date').datepicker({
             changeMonth: true,changeYear: true,showButtonPanel: true,showOn: 'button',buttonImage: '../../images/visualcore/calendar.gif',buttonImageOnly: true,
       
             onClose: function() {me.fillContent();}
          });

        me.fillContent();

        me.visual.find('#ddl-signal').off('change').on('change', function () { me.fillContent(); }).chosen();
        me.visual.find('.button-toggle').off('click').on('click', function () {
            me.visual.find(".button-toggle").removeClass("button-toggle-active");
            $(this).addClass("button-toggle-active");
            me.fillContent();
        });

    } catch (ex) { me.writeError('init', ex); }
};



SingleSignal.prototype.fillContent = function () {
    /// <summary>
    /// Inits the form and the chart. <br/>
    /// </summary>   
    var me = this;
    var bsaid;
    var type;
    var param;
    var day;
    try {

        day = me.visual.find("#txt-date").val();
        bsaid = parseInt(me.visual.find("#ddl-signal").val(), 10);

        param = { 'loggerid': me.blid, 'day': day, 'bsaid': [bsaid] };


        type = me.visual.find(".button-toggle-active").attr("id");

        me.visual.find("#div-content").html(me.vcC.getLoadingIcon());
       // alert(type);
        switch (type) {
            case "btn-values":
                param.SingleSignal = true;
                me.vcVisual.addVisualBaseByName('div-', 'VISUAL_DATACENTER_EDIT_RANGE', 'content', getCurrentTimestamp(), parseInt(me.visual.find("#div-content").height(), 10), parseInt(me.visual.find("#div-content").width(), 10), JSON.stringify(param), "", me.deviceType);
                break;

            case "btn-status":
                me.vcVisual.addVisualBaseByName('div-', 'VISUAL_DATACENTER_ARCHIVESTATUS', 'content', getCurrentTimestamp(), parseInt(me.visual.find("#div-content").height(), 10)-20, parseInt(me.visual.find("#div-content").width(), 10)-40,  JSON.stringify(param), "", me.deviceType);
                break;

            case "btn-info":
                me.vcVisual.addVisualBaseByName('div-', 'VISUAL_SIGNALANALOG_SUMMARY', 'content', getCurrentTimestamp(), parseInt(me.visual.find("#div-content").height(), 10), parseInt(me.visual.find("#div-content").width(), 10), "", JSON.stringify({ 'bsaid': bsaid }), me.deviceType);

                break;
            
        default:
        }


    } catch (ex) { me.writeError('fillContent', ex); }
};
